
import Assert from "tbAssert";

const mStateDataSvc = new WeakMap();
const mQSvc = new WeakMap();

class StateCommonSubscriptionService {
    constructor($q, StateData) {
        Assert.StrictAssert($q != null, "Assertion Failure: Missing Q Service Dependency");
        Assert.StrictAssert(StateData != null, "Assertion Failure: Missing State Data Service Dependency");

        mQSvc.set(this, $q);
        mStateDataSvc.set(this, StateData);
    }
    
    getTarget(stateTargetId) {
        let stateRetrievalPromise =
            mStateDataSvc.get(this)
                .getCore({stateId: stateTargetId})
                .$promise
                .then(
                    (retrievedState) => {
                        return retrievedState.result;
                    },
                    (errorResponse) => {
                        return mQSvc.get(this).reject(errorResponse);
                    }
                );

        return stateRetrievalPromise;
    }

    getTargetBatch(stateTargetIds) {
        let stateRetrievalPromises = stateTargetIds.map((stateId) => this.getTarget(stateId));

        return mQSvc.get(this).all(stateRetrievalPromises);
    }

    addSubscription(recipientId, stateTargetId, subAddFn, getSubsFn) {
        let subAddPromise = subAddFn({
            stateId: stateTargetId,
            recipientId: recipientId
        })
        .$promise
        .then(
            (updatedStateResource) => {
                let updatedState = updatedStateResource.result;
                let selectedSubs = getSubsFn(updatedState);
                let numSubs = selectedSubs.length;
                let foundSubscriber = false;
                for (let subIdx = 0; (!foundSubscriber) && (subIdx < numSubs); subIdx++) {
                    if (selectedSubs[subIdx].recipientId === recipientId) {
                        foundSubscriber = true;
                    }
                }
                if (!foundSubscriber) {
                    return mQSvc.get(this).reject("Failed to add subscription.");
                }
                else {
                    return true;
                }
            }, (errorResponse) => {
                return mQSvc.get(this).reject(errorResponse);
            }
        );

        return subAddPromise;
    }

    removeSubscription(recipientId, stateTargetId, subDelFn, getSubsFn) {
        let subDelPromise = subDelFn({
            stateId: stateTargetId,
            recipientId: recipientId
        })
        .$promise
        .then(
            (updatedStateResource) => {
                let updatedState = updatedStateResource.result;
                let selectedSubs = getSubsFn(updatedState);
                let numSubs = selectedSubs.length;
                let foundSubscriber = false;
                for (let subIdx = 0; (!foundSubscriber) && (subIdx < numSubs); subIdx++) {
                    if (selectedSubs[subIdx].recipientId === recipientId) {
                        foundSubscriber = true;
                    }
                }
                if (!foundSubscriber) {
                    return true;
                }
                else {
                    return mQSvc.get(this).reject("Failed to add subscription.");
                }
            },
            (errorResponse) => {
                return mQSvc.get(this).reject(errorResponse);
            }
        );

        return subDelPromise;
    }
}

export default StateCommonSubscriptionService;



//////////////////
// WEBPACK FOOTER
// ./src/services/subscription-data-services/StateCommonSubscriptionService.js
// module id = Qj+F
// module chunks = 1